/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VitalScoreStrictHttpResponse } from '../../vital-score-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessTokenModel } from '../../models/access-token-model';
import { RegisterModel } from '../../models/register-model';

export interface HealthWithHeartRegisterProfilePost$Params {
      body?: RegisterModel
}

export function healthWithHeartRegisterProfilePost(http: HttpClient, rootUrl: string, params?: HealthWithHeartRegisterProfilePost$Params, context?: HttpContext): Observable<VitalScoreStrictHttpResponse<AccessTokenModel>> {
  const rb = new RequestBuilder(rootUrl, healthWithHeartRegisterProfilePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VitalScoreStrictHttpResponse<AccessTokenModel>;
    })
  );
}

healthWithHeartRegisterProfilePost.PATH = '/HealthWithHeart/RegisterProfile';
